import axios from "axios";

const tokenHttpClient = axios.create();

export const noTokenHttpClient = axios.create();

export default tokenHttpClient;
